import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// native components
import LeadersTwoColumnContent from '../leadersTwoColumnContent';
// images
import profilePicWebp from './images/kamilah-williams-kemp.webp';
// styles
import {
  LinkedinStyledSocialIcon,
  LinkStyledBio,
} from '../../styles';

export default () => {
  const name = 'Kamilah D. Williams-Kemp';
  const nameString = 'kamilah-williams-kemp';
  const title = 'Chief Product Officer';

  return (
    <LeadersTwoColumnContent
      id='leaders-chief-product-officer'
      header={name}
      title={title}
      isExecutiveVicePresident
      content={(
        <>
          <Typography
            itemprop='description'
            nextElement='link'>
            Kamilah oversees the strategy and growth of the company&#39;s industry&#45;leading insurance business that represents &#36;2.3 trillion of insurance protection across more than 5.1 million clients and &#36;7.3 billion of dividends paid to policyowners in 2024. She leads all elements of the insurance business value chain&#8212;including product development, sales support, underwriting, and the claims experience. She is also accountable for delivering the field and client service experience across insurance and investments.
          </Typography>
          <LinkStyledBio
            id={`leaders-section-${nameString}-bio-pdf-link`}
            linkUrl='/assets/pdf/leaders/williams-kemp-kamilah-bio.pdf'
            ariaLabel={`Download the bio pdf for ${name}`}
            isInternalPdf
            endAdornment={CaratRight}
            endAdornmentStylesReset
            variant='buttonLinkTertiary'>
            See full bio
          </LinkStyledBio>
          <Row>
            <Col nested>
              <Link
                id={`leaders-section-${nameString}-linkedin-social-link`}
                variant='primary'
                linkUrl='https://www.linkedin.com/in/kamilah-williams-kemp-b9b2942/'
                ariaLabel={`${name} Linkedin profile`}
                isOutgoingLink>
                <LinkedinStyledSocialIcon />
              </Link>
            </Col>
          </Row>
        </>
      )}
      image={profilePicWebp}
      imageAlt={`Northwestern Mutual Executive Vice President and ${title} ${name}.`}
      reversed
    />
  );
};
